import {round} from '@utils/numbers';

// Micronutrient field catalogues, shared app-wide (moved out of BaseMixin's
// per-instance data). Read-only — no consumer mutates them.

export const microNutrientFields = ['saturatedFats', 'monounsaturatedFats', 'polyunsaturatedFats', 'cholesterol',
    'monodisaccharides', 'polysaccharides', 'dietaryFibers', 'water', 'alcohol', 'natrium',
    'potassium', 'calcium', 'magnesium', 'phosphorus', 'iron', 'zinc', 'retinol', 'carotene',
    'thiamine', 'riboflavin', 'vitaminB6', 'vitaminC', 'sugars', 'vitaminA',
    'caroteneA', 'caroteneB', 'cryptoxanthin', 'lycopene', 'lutein_zeaxanthin', 'niacin',
    'folicAcid', 'folateFood', 'folateDFE', 'folateTotal', 'choline', 'vitaminB12', 'vitaminB12Added',
    'vitaminD', 'vitaminE', 'vitaminK', 'copper', 'selenium', 'caffeine', 'theobromine'
];

export const bothCategoriesMicronutrients = ['saturatedFats', 'monounsaturatedFats', 'polyunsaturatedFats', 'cholesterol', 'dietaryFibers', 'water', 'alcohol', 'natrium',
    'potassium', 'calcium', 'magnesium', 'phosphorus', 'iron', 'zinc', 'retinol',
    'thiamine', 'riboflavin', 'vitaminB6', 'vitaminC'];

export const trixopoulouMicronutrients = ['monodisaccharides', 'polysaccharides', 'carotene'];

export const usdaMicronutrients = ['sugars', 'vitaminA',
    'caroteneA', 'caroteneB', 'cryptoxanthin', 'lycopene', 'lutein_zeaxanthin', 'niacin',
    'folicAcid', 'folateFood', 'folateDFE', 'folateTotal', 'choline', 'vitaminB12', 'vitaminB12Added',
    'vitaminD', 'vitaminE', 'vitaminK', 'copper', 'selenium', 'caffeine', 'theobromine'];

// Map a client's sex/age onto the DRI table buckets. Moved from BaseMixin.
export const formatDriObject = (gender, age) => {
    let fixedGender = gender === 'M' ? 'male' : 'female';
    let fixedAge = null;

    let ageRanges = ['7–12', '1–3', '4–8', '9–13', '14–18', '19–30', '31–50', '51–70', '71'];

    if (age < 9) fixedGender = 'children'
    else if (age < 1) fixedGender = 'infants'

    if (age < 1) {
        fixedAge = ageRanges[0]
    } else if (age < 4) {
        fixedAge = ageRanges[1]
    } else if (age < 9) {
        fixedAge = ageRanges[2]
    } else if (age < 14) {
        fixedAge = ageRanges[3]
    } else if (age < 19) {
        fixedAge = ageRanges[4]
    } else if (age < 31) {
        fixedAge = ageRanges[5]
    } else if (age < 51) {
        fixedAge = ageRanges[6]
    } else {
        fixedAge = ageRanges[7]
    }

    return {
        age: fixedAge,
        gender: fixedGender
    }
}

// A daily macro split worked out from grams per kg carries long decimals (48.484848…). Each total to two
// decimals; when the split adds up to 100, fats take what's left so it still does.
export const roundMacroSplit = (nutrients) => {
    const {carbs, proteins, fats} = nutrients;
    const addsUp = Math.abs(parseFloat(carbs.total) + parseFloat(proteins.total) + parseFloat(fats.total) - 100) < 0.01;
    carbs.total = round(carbs.total);
    proteins.total = round(proteins.total);
    fats.total = round(addsUp ? 100 - carbs.total - proteins.total : fats.total);
};
